export default "__VITE_ASSET__DyGKVTA0__"